import { z } from 'zod'
import { IsoDateTimeSchema, OkResponseSchema, UuidSchema } from '../primitives'
import { route } from '../route-def'

/** Member groups (many-to-many), used to address communications (AC8). */

export const GroupSchema = z.object({
  id: UuidSchema,
  name: z.string(),
  memberCount: z.number().int().min(0),
  createdAt: IsoDateTimeSchema,
})
export type Group = z.infer<typeof GroupSchema>

export const GroupNameBodySchema = z.object({ name: z.string().trim().min(1).max(80) })
export const GroupMembersBodySchema = z.object({ memberIds: z.array(UuidSchema).min(1).max(1000) })
const GroupIdParamsSchema = z.object({ id: UuidSchema })

export const groupsRoutes = {
  adminGroups: route({
    method: 'GET',
    path: '/api/admin/groups',
    auth: 'admin',
    response: z.object({ groups: z.array(GroupSchema) }),
  }),
  adminGroupCreate: route({
    method: 'POST',
    path: '/api/admin/groups',
    auth: 'admin',
    body: GroupNameBodySchema,
    response: z.object({ group: GroupSchema }),
  }),
  adminGroupRename: route({
    method: 'PATCH',
    path: '/api/admin/groups/:id',
    auth: 'admin',
    params: GroupIdParamsSchema,
    body: GroupNameBodySchema,
    response: z.object({ group: GroupSchema }),
  }),
  adminGroupDelete: route({
    method: 'DELETE',
    path: '/api/admin/groups/:id',
    auth: 'admin',
    params: GroupIdParamsSchema,
    response: OkResponseSchema,
  }),
  adminGroupAddMembers: route({
    method: 'POST',
    path: '/api/admin/groups/:id/members',
    auth: 'admin',
    params: GroupIdParamsSchema,
    body: GroupMembersBodySchema,
    response: z.object({ added: z.number().int().min(0) }),
  }),
  adminGroupRemoveMembers: route({
    method: 'DELETE',
    path: '/api/admin/groups/:id/members',
    auth: 'admin',
    params: GroupIdParamsSchema,
    body: GroupMembersBodySchema,
    response: z.object({ removed: z.number().int().min(0) }),
  }),
}
